export const playerRoutes = [
  "SharedMain",
  "PlayerMain",
  "PlayerMainFullscreen",
  "PublicPlayerMain",
  "PlayerFullscreenPublic",
  "UserProfileMain",
];
